module.exports = __webpack_public_path__ + "static/media/onboarding.6a98929f.png";